import { FC } from 'react';
import cn from 'classnames';

import PlainItem from './PlainItem';
import styles from './PlainItemsWithDescription.module.scss';

import { OptionalListInterface } from '../config/declarations';

export const PlainItems: FC<OptionalListInterface> = ({
  blocks,
}) => {
  if (!blocks?.length) {
    return null;
  }

  const siblingsAmount = (blocks.length < 6) ? blocks.length : 5;

  return (
    <ul className={cn(styles.content, styles[`content${siblingsAmount}`])}>
      {blocks.map((link) => (
        <PlainItem
          key={link.entryName}
          block={link}
          siblingsAmount={siblingsAmount}
        />
      ))}
    </ul>
  );
};
